import { render, staticRenderFns } from "./section-header.vue?vue&type=template&id=67bc37eb&scoped=true&"
import script from "./section-header.vue?vue&type=script&lang=js&"
export * from "./section-header.vue?vue&type=script&lang=js&"
import style0 from "./section-header.vue?vue&type=style&index=0&id=67bc37eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bc37eb",
  null
  
)

export default component.exports